import { ChartData } from "atoms/Ltool/chartAtoms";
import { AchievementCategoryMap, AchievementLevelData } from "atoms/Ltool/matrixAtoms";
import { UNIT_IDS } from "utils/constsLtool";

/** 空の achievementLevelData を返すユーティリティ */
export function createEmptyAllMatrixData(conditionIds: string[]): AchievementLevelData {
    const achievementLevel = UNIT_IDS.reduce<Record<string, AchievementCategoryMap>>((unitAcc, unitId) => {
        const conditionMap = conditionIds.reduce<AchievementCategoryMap>((conditionAcc, conditionId) => {
            conditionAcc[conditionId] = {
                assessment: null,
                deviation_max: null,
            };
            return conditionAcc;
        }, {});

        unitAcc[unitId] = conditionMap;
        return unitAcc;
    }, {});

    return {
        message: "",
        achievement_level: achievementLevel,
    };
};

type Status = 'notstarted' | 'loading' | 'success' | 'error';

/** 空の allChartData を返すユーティリティ */
export function createEmptyAllChartData(
    conditionIds: string[],
    initialStatus: Status = 'loading'
): Record<string, ChartData> {
    return conditionIds.reduce<Record<string, ChartData>>((acc, id) => {
        acc[id] = {
            data: { target: [], measurement: [], measurement_corrected: [], NG_freq: null, vel: [], rpm: [] },
            status: initialStatus,
        };
        return acc;
    }, {});
};
